<template>
  <div>
    <v-btn color="primary" dark class="mb-2 hbtn" to="/scheduled_messages/store"
      >{{ $t('messagingPage.newScheduledMessage') }}</v-btn
    >
    <DataTable
      ref="reserDataTable"
      :url="api.ACTIONS.GLOBAL_MESSAGE"
      :titles="titles"
      :fields-hidden-main="['id', 'updated_at','deleted_at']"
      :title="$t('messagingPage.pageTitle')"
      :enableEdit="false"
      :enableAdd="false"
      :enableDelete="false"
      :actions-extra-main="actionsExtraMain"
      :formatter="formatters"
    />
  </div>
</template>

<style>
.hbtn {
  float: inline-end;
  z-index: 1;
  margin-top: 20px;
  margin-inline-end: 20px;
  padding: 0px 45px;
}
</style>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";

const required = (val) =>
  (val !== null && val !== undefined) || "this field is required";

export default {
  name: "Scheduled Messages",
  title() {
    return this.$t("messagingPage.pageTitle");
  },
  components: { DataTable },
  data() {
    return {
      formatters: {
        // Final-version doc 2026-10-05: company clock (UTC+3).
        created_at(value) {
          return formatCompanyTime(value, "DD-MM-YYYY HH:mm");
        },
        end_time(value) {
          return formatCompanyTime(value, "DD-MM-YYYY HH:mm");
        },
      },
    };
  },

  computed: {
    rules() {
      return {
        name: [required],
      };
    },
    titles() {
      return {
        id: this.$t("messagingPage.colId"),
        created_at: this.$t("messagingPage.start"),
        end_time: this.$t("messagingPage.end"),
        step: this.$t("messagingPage.interval"),
        message: this.$t("messagingPage.message"),
      };
    },
    actionsExtraMain() {
      return {
        deleteMessage: {
          title: this.$t("messagingPage.deleteScheduledMessage"),
          icon: "delete_forever",
          action: ({ id }) => {
            this.loading = true;
            this.axios
              .delete(`global_message/${id}`)
              .then((res) => {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("messagingPage.deletedSuccessfully"),
                  "green"
                );
                this.$refs.reserDataTable.getData();
              })
              .catch((err) => {
                let response = err.response;
                if (response) {
                  window.getApp.$emit(
                    "SHOW_TOAST",
                    response.data.message,
                    "red"
                  );
                } else {
                  window.getApp.$emit(
                    "SHOW_TOAST",
                    this.$t("messagingPage.somethingWrong"),
                    "red"
                  );
                }
              })
              .finally(() => (this.loading = false));
          },
        },
      };
    },
  },
};
</script>
